// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"728":"b3e94af5","885":"24216c7c"}[chunkId] + ".chunk.js");